import { render, staticRenderFns } from "./TeamEditModal.vue?vue&type=template&id=3704c515&"
import script from "./TeamEditModal.vue?vue&type=script&lang=js&"
export * from "./TeamEditModal.vue?vue&type=script&lang=js&"
import style0 from "./TeamEditModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports